'use client'

import { useQuery } from '@tanstack/react-query'
import { apiFetch } from '@/core/utils/api-client'

export interface ActiveTimerSession {
  id: string
  userId: string
  description: string | null
  startTime: string
  issueId: string | null
  projectId: string | null
  youtrackWorkTypeId?: string | null
  pausedAt: string | null
  accumulatedSeconds: number
  currentSegmentStart: string | null
  segments: Array<{ start: string; end: string }>
  issue?: {
    id: string
    issueId: string
    summary: string
    projectId: string | null
  } | null
  project?: {
    id: string
    shortName: string
    name: string
  } | null
}

/**
 * Fetches the user's active timer session.
 * Polls every 60s as a fallback; primary updates come via WebSocket.
 */
export function useActiveTimer() {
  return useQuery<ActiveTimerSession | null>({
    queryKey: ['/api/timetracking/sync'],
    queryFn: async () => {
      const res = await apiFetch('/api/timetracking/sync')
      if (!res.ok) return null
      const data = await res.json()
      return data ?? null
    },
    refetchInterval: 60_000,
    staleTime: 30_000,
  })
}
